// PrivacyPolicy.js

import React from 'react';

const sectionStyle = {
  marginBottom: 32,
  paddingBottom: 24,
  borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
};

const lastSectionStyle = {
  marginBottom: 32,
};

const h1Style = {
  fontSize: 28,
  fontWeight: 600,
  marginBottom: 8,
};

const h2Style = {
  fontSize: 20,
  fontWeight: 600,
  marginTop: 0,
  marginBottom: 12,
};

const h3Style = {
  fontSize: 16,
  fontWeight: 500,
  marginTop: 16,
  marginBottom: 8,
  opacity: 0.85,
};

const pStyle = {
  lineHeight: 1.7,
  marginBottom: 12,
  opacity: 0.9,
  fontSize: 15,
};

const containerStyle = {
  maxWidth: 780,
  margin: '0 auto',
  padding: '40px 24px',
};

const tocStyle = {
  marginBottom: 32,
  paddingBottom: 24,
  borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
};

const tocLinkStyle = {
  display: 'block',
  padding: '6px 0',
  opacity: 0.8,
  cursor: 'pointer',
  fontSize: 14,
  textDecoration: 'none',
  color: 'inherit',
};

const sections = [
  { id: 'types', label: 'Types of Information Collected' },
  { id: 'purposes', label: 'Purposes for which we hold your Information' },
  { id: 'biometric', label: 'Biometric Login' },
  { id: 'disclosure', label: 'Disclosure of Information to Third Parties' },
  { id: 'sale', label: 'Sale of Business' },
  { id: 'security', label: 'Security' },
  { id: 'updating', label: 'Updating, Verifying and Deleting Personal Data' },
  { id: 'changes', label: 'Changes to the Website Privacy Policy' },
];

const PrivacyPolicy = () => {
  return (
    <div style={containerStyle}>
      <div style={{ ...sectionStyle, textAlign: 'center', paddingBottom: 32 }}>
        <h1 style={h1Style}>Privacy Policy</h1>
        <p style={{ ...pStyle, maxWidth: 600, margin: '0 auto' }}>We respect your right to privacy and comply with our obligations under the Data Protection Acts 1988 and 2002. The purpose of this Website Privacy Policy is to outline how we deal with any personal data you provide to us while visiting this website. Naturally, if you are not happy with this Website Privacy Policy you should not use this website.</p>
      </div>

      <div style={tocStyle}>
        <h2 style={{ ...h2Style, marginBottom: 8 }}>Contents</h2>
        {sections.map((s) => (
          <a key={s.id} href={`#${s.id}`} style={tocLinkStyle}>{s.label}</a>
        ))}
      </div>

      <div style={sectionStyle}>
        <h2 id="types" style={h2Style}>Types of Information Collected</h2>
        <p style={pStyle}>We retain two types of information:</p>
        <h3 style={h3Style}>Personal Data</h3>
        <p style={pStyle}>Data that identifies you or can be used to contact you, including:</p>
        <ul style={{ ...pStyle, paddingLeft: 24 }}>
          <li>Name and address</li>
          <li>Email address</li>
          <li>Telephone number</li>
          <li>Birth date</li>
          <li>User IP addresses (where not anonymised)</li>
          <li>Billing and credit card information</li>
        </ul>
        <p style={pStyle}>Such information is only collected from you if you voluntarily submit it to us.</p>
        <h3 style={h3Style}>Non-Personal Data</h3>
        <p style={pStyle}>Aggregate statistical information that cannot identify you, such as:</p>
        <ul style={{ ...pStyle, paddingLeft: 24 }}>
          <li>Anonymised user IP addresses</li>
          <li>Browser types</li>
          <li>Anonymous usage statistics</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2 id="purposes" style={h2Style}>Purposes for which we hold your Information</h2>
        <h3 style={h3Style}>Non-Personal Data</h3>
        <p style={pStyle}>We use the Non-Personal Data gathered from visitors to our website in an aggregate form to get a better understanding of where our visitors come from and to help us better design and organise our website.</p>
        <h3 style={h3Style}>Cookies</h3>
        <p style={pStyle}>This website does not use "cookie" technology.</p>
        <h3 style={h3Style}>Personal Data</h3>
        <p style={pStyle}>We will process any Personal Data you provide to us for the following purposes to provide you with the goods or services you have ordered.</p>
      </div>

      <div style={sectionStyle}>
        <h2 id="biometric" style={h2Style}>Biometric Login</h2>
        <p style={pStyle}>For our mobile app we provide the option of biometric login.</p>
        <p style={pStyle}>The Face Data is in your personal device and NOT in our database.</p>
        <p style={pStyle}>Face Data is solely for enabling your biometric login and not for any other purpose.</p>
      </div>

      <div style={sectionStyle}>
        <h2 id="disclosure" style={h2Style}>Disclosure of Information to Third Parties</h2>
        <p style={pStyle}>We do NOT provide Personal or Non-Personal data to third parties.</p>
      </div>

      <div style={sectionStyle}>
        <h2 id="sale" style={h2Style}>Sale of Business</h2>
        <p style={pStyle}>We reserve the right to transfer information (including your Personal Data) to a third party in the event of a sale, merger, liquidation, receivership or transfer of all or substantially all of the assets of our company provided that the third party agrees to adhere to the terms of the Website Privacy Policy and provided that the third party only uses your Personal Data for the purposes that you provided it to us. You will be notified in the event of any such transfer and you will be afforded an opportunity to opt-out.</p>
      </div>

      <div style={sectionStyle}>
        <h2 id="security" style={h2Style}>Security</h2>
        <p style={pStyle}>Your Personal Data is held on secure servers hosted by TransIP. The nature of the Internet is such that we cannot guarantee or warrant the security of any information you transmit to us via the Internet. No data transmission over the Internet can be guaranteed to be 100% secure. However, we will take all reasonable steps (including appropriate technical and organisational measures) to protect your Personal Data.</p>
      </div>

      <div style={sectionStyle}>
        <h2 id="updating" style={h2Style}>Updating, Verifying and Deleting Personal Data</h2>
        <p style={pStyle}>You may inform us of any changes in your Personal Data, and in accordance with our obligations under the Data Protection Acts 1988 and 2002 we will update or delete your Personal Data accordingly. To find out what Personal Data we hold on you or to have your Personal Data updated, amended or removed from our database, please email us at a request to the email address at the foot of this site. Any such data subject requests may be subject to the prescribed fee.</p>
      </div>

      <div style={lastSectionStyle}>
        <h2 id="changes" style={h2Style}>Changes to the Website Privacy Policy</h2>
        <p style={pStyle}>Any changes to this Website Privacy Policy will be posted on this website so you are always aware of what information we collect, how we use it, and under what circumstances, if any, we disclose it. If at any time we decide to use Personal Data in a manner significantly different from that stated in this Website Privacy Policy, or otherwise disclosed to you at the time it was collected, we will notify you by email, and you will have a choice as to whether or not we use your information in the new manner.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
